<!-- 布局-content -->
<template>
  <div class="app-content">
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {}
  },
  computed: {
    key () {
      return this.$route.path
    }
  },
  watch: {},
  mounted () {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.app-content {
  min-height: calc(
    100vh - 110px
  ); // 最小高度 100vh - （导航栏高度70 + 上下20边距）
}

/* fade-transform */
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.5s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
